<template>
  <v-select
    :value="selectedCurrencyId"
    :items="currencies"
    item-value="id"
    :item-text="getCurrencyText"
    label="Select currency"
    :loading="value"
    :readonly="isReadOnly"
    @change="onSelect"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RaCurrencySelection',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userCurrencyId: {
      type: Number,
      default: 0
    },
    isReadOnly: { // Currency will be set and readonly if the user already has a stripe account
      type: Boolean,
      default: false
    },
    defaultCurrencyCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedCurrencyId: 0
    }
  },
  computed: {
    ...mapGetters('currencies', ['currencies'])
  },
  async mounted () {
    this.isLoading(true)
    await this.getCurrencies()
    this.isLoading(false)
    this.initialiseSelect()
  },
  methods: {
    ...mapActions('currencies', [
      'getCurrencies'
    ]),
    initialiseSelect () {
      // Set user's currency, fallback to cashier default
      if (this.userCurrencyId) {
        this.selectedCurrencyId = this.userCurrencyId
      } else {
        // eslint-disable-next-line camelcase
        const currencyObj = this.currencies.find(({ iso_code }) => iso_code === this.defaultCurrencyCode)
        this.selectedCurrencyId = currencyObj ? currencyObj.id : 1 // Id for $USD is 1
      }
      if (this.selectedCurrencyId) {
        this.onSelect(this.selectedCurrencyId)
      }
    },
    getCurrencyText (item) {
      return `${item.name} - ${item.symbol}`
    },
    isLoading (value) {
      this.$emit('input', value)
    },
    onSelect (currencyId) {
      this.$emit('currency-selected', this.currencies.find(currency => currency.id === currencyId))
    }
  }
}
</script>
